export const jhsWorks = {
  movie: [
    {
      id: 1,
      title: '만해 한용운 님의침묵',
      year: '2023',
      image: require('./movie/1. 만해 한용운 님의침묵.webp')
    },
    {
      id: 2,
      title: '엄마없는 하늘 아래',
      year: '2022',
      image: require('./movie/2. 엄마없는 하늘 아래.webp')
    },
    {
      id: 3,
      title: '헬머니',
      year: '2021',
      image: require('./movie/3. 헬머니.webp')
    },
    {
      id: 4,
      title: '제4이노베이터',
      year: '2020',
      image: require('./movie/4. 제4이노베이터.webp')
    },
    {
      id: 5,
      title: '카운트다운',
      year: '2019',
      image: require('./movie/5. 카운트다운.webp')
    },
    {
      id: 6,
      title: '날아라 펭귄',
      year: '2018',
      image: require('./movie/6. 날아라 펭귄.webp')
    }
  ],
  drama: [
    {
      id: 1,
      title: '피도 눈물도 없이',
      year: '2023',
      image: require('./drama/1. 피도 눈물도 없이.webp')
    },
    {
      id: 2,
      title: '내 눈에 콩깍지',
      year: '2022',
      image: require('./drama/2. 내 눈에 콩깍지.webp')
    },
    {
      id: 3,
      title: '숨바꼭질',
      year: '2021',
      image: require('./drama/3. 숨바꼭질.webp')
    },
    {
      id: 4,
      title: '우리가 사랑했던 모든 것',
      year: '2020',
      image: require('./drama/4. 우리가 사랑했던 모든 것.webp')
    },
    {
      id: 5,
      title: '당신은 너무합니다',
      year: '2019',
      image: require('./drama/5. 당신은 너무합니다.webp')
    },
    {
      id: 6,
      title: '미녀공심이',
      year: '2018',
      image: require('./drama/6. 미녀공심이.webp')
    },
    {
      id: 7,
      title: '굿바이 미스터 블랙',
      year: '2017',
      image: require('./drama/7. 굿바이 미스터 블랙.webp')
    },
    {
      id: 8,
      title: '전설의 마녀',
      year: '2016',
      image: require('./drama/8. 전설의 마녀.webp')
    },
    {
      id: 9,
      title: '압구정 백야',
      year: '2015',
      image: require('./drama/9. 압구정 백야.webp')
    },
    {
      id: 10,
      title: '유혹',
      year: '2014',
      image: require('./drama/10. 유혹.webp')
    }
  ],
};